import React, { useEffect } from 'react';
import { ssoLogout } from '../api/ssoAuth';
import { getRedirectUri } from '../utils/redirectHelper';
import { publishLogoutEvent } from '../services/mqttLogoutService';

const Logout = () => {
  useEffect(() => {
    const handleLogout = async () => {
      const token = localStorage.getItem('kit19_sso_token');
      const deviceId = localStorage.getItem('kit19_device_id');
      const userData = localStorage.getItem('kit19_user_data');
      const redirectUri = getRedirectUri();

      // Parse user data to get userId
      let userId = null;
      if (userData) {
        try {
          const user = JSON.parse(userData);
          userId = user.id || user.userId || user.email;
        } catch (e) {
          console.warn('Failed to parse user data:', e);
        }
      }

      // First, invalidate the SSO session server-side
      if (token) {
        try {
          await ssoLogout(token);
        } catch (error) {
          console.error('Logout error:', error);
        }
      }

      // Then publish logout event to MQTT so other apps can logout
      if (deviceId && userId) {
        try {
          console.log('🔔 Publishing logout event to MQTT for device:', deviceId);
          await publishLogoutEvent(deviceId, userId, 'Kit19SSO');
          await new Promise(resolve => setTimeout(resolve, 500));
        } catch (error) {
          console.warn('⚠️ Failed to publish logout event via MQTT:', error);
        }
      }

      // Clear all SSO data from this domain
      localStorage.removeItem('kit19_sso_token');
      localStorage.removeItem('kit19_user_data');
      localStorage.removeItem('kit19_device_id');

      // Redirect back to app with logout signal
      if (redirectUri) {
        // Include logout flag so client app knows to clear its session
        const separator = redirectUri.includes('?') ? '&' : '?';
        const logoutUrl = `${redirectUri}${separator}logout=true`;
        console.log('Redirecting to app with logout signal:', logoutUrl);
        window.location.href = logoutUrl;
      } else {
        window.location.href = '/login';
      }
    };

    handleLogout();
  }, []);

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <div style={{
        background: 'white',
        padding: '48px',
        borderRadius: '16px',
        textAlign: 'center'
      }}>
        <h2>Logging out...</h2>
        <p>Please wait</p>
      </div>
    </div>
  );
};

export default Logout;
